import { ComposedChart, Line, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import { CHART_COLORS, CHART_PALETTE } from '@/lib/chart-theme'
import { StatCard, ChartTooltip, InfoTooltip } from './shared'

export function ResponseTimeReport({ data }: { data: any }) {
  const { summary, chartData } = data

  return (
    <div className="rep-report">
      <div className="rep-stats-row">
        <StatCard title="Avg Time to View" value={`${summary.avgViewTime} days`} color={CHART_COLORS.blue} />
        <StatCard title="Avg Time to Sign" value={`${summary.avgSignTime} days`} color={CHART_PALETTE[1]} />
        <StatCard title="Total Proposals" value={summary.totalProposals} />
      </div>

      <div className="rep-charts-row">
        <div className="rep-chart-card rep-chart-full">
          <InfoTooltip text="Dual trend lines with dot markers track view and sign response times over time — the separation between the two lines reveals how long clients deliberate after first viewing." />
          <ResponsiveContainer width="100%" height={360}>
            <ComposedChart data={chartData.monthly} margin={{ top: 10, right: 10, left: -10, bottom: 0 }}>
              <defs>
                <linearGradient id="gradViewTime" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor={CHART_COLORS.blue} stopOpacity={0.12} />
                  <stop offset="95%" stopColor={CHART_COLORS.blue} stopOpacity={0} />
                </linearGradient>
                <linearGradient id="gradSignTime" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor={CHART_PALETTE[1]} stopOpacity={0.12} />
                  <stop offset="95%" stopColor={CHART_PALETTE[1]} stopOpacity={0} />
                </linearGradient>
              </defs>

              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
              <XAxis
                dataKey="month"
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12, fill: '#94A3B8' }}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12, fill: '#94A3B8' }}
                unit=" days"
              />

              <Tooltip content={<ChartTooltip />} />

              {/* Background areas with subtle gradients */}
              <Area
                type="monotone"
                dataKey="avgViewDays"
                fill="url(#gradViewTime)"
                stroke="none"
                isAnimationActive={false}
              />
              <Area
                type="monotone"
                dataKey="avgSignDays"
                fill="url(#gradSignTime)"
                stroke="none"
                isAnimationActive={false}
              />

              {/* Foreground lines with dots */}
              <Line
                type="monotone"
                dataKey="avgViewDays"
                name="Time to View"
                stroke={CHART_COLORS.blue}
                strokeWidth={2.5}
                dot={{
                  r: 4,
                  fill: CHART_COLORS.blue,
                  stroke: '#fff',
                  strokeWidth: 2,
                }}
                activeDot={{ r: 6 }}
                isAnimationActive={false}
              />
              <Line
                type="monotone"
                dataKey="avgSignDays"
                name="Time to Sign"
                stroke={CHART_PALETTE[1]}
                strokeWidth={2.5}
                dot={{
                  r: 4,
                  fill: CHART_PALETTE[1],
                  stroke: '#fff',
                  strokeWidth: 2,
                }}
                activeDot={{ r: 6 }}
                isAnimationActive={false}
              />
            </ComposedChart>
          </ResponsiveContainer>

          {/* Custom legend */}
          <div className="rep-area-legend">
            <div className="rep-area-legend-item">
              <span
                className="rep-area-legend-dot"
                style={{ backgroundColor: CHART_COLORS.blue }}
              />
              <span>Time to View</span>
            </div>
            <div className="rep-area-legend-item">
              <span
                className="rep-area-legend-dot"
                style={{ backgroundColor: CHART_PALETTE[1] }}
              />
              <span>Time to Sign</span>
            </div>
          </div>
        </div>
      </div>

      <div className="rep-table-card">
        <h3 className="rep-chart-title">Monthly Breakdown</h3>
        <table className="rep-table">
          <thead>
            <tr>
              <th>Month</th>
              <th>Avg View (days)</th>
              <th>Avg Sign (days)</th>
              <th>Proposals</th>
            </tr>
          </thead>
          <tbody>
            {chartData.monthly.map((r: any, i: number) => (
              <tr key={i}>
                <td>{r.month}</td>
                <td>{r.avgViewDays}</td>
                <td>{r.avgSignDays}</td>
                <td>{r.proposalCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
